import { cloneDeep } from 'lodash';
import Vue from 'vue';
import $ from 'jquery';
import 'vue2-timepicker/src/vue-timepicker.vue';
// VueSlider style
import 'vue-slider-component/theme/default.css';
// eslint-disable-next-line no-unused-vars
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

/* ===================
 * Plugins
 * ===================
 *
 * Import and bootstrap plugins.
 */

// Utils
import * as navUtils from '@/utils/navigation';
import * as navUtilConsts from '@/utils/navigation-constants';
import IATeacher from '@/utils/classes/IATeacher';

import './plugins/vuex';
import './plugins/vue-axios';
import './plugins/vue-moment';
import './plugins/vue-chartjs';
import './plugins/lodash';
import './plugins/jquery';
import './plugins/toastr';
import './plugins/exifr';
import './plugins/registerServiceWorker';

import './utils/indicator-utils';
import './directives/click-outside';
import './directives/field-visible';
import './directives/no-dbl-tap-zoom';
import './directives/quick-title';
import './directives/resize-event';
import './directives/visible';

// WARNING: Store must be imported before router since the router uses the store
// for multiple features, such as the pages language
import App from '@/App.vue';
import store from '@/store';
import { router } from './plugins/router';
import { isMobile } from './utils/main';

import { i18n } from './plugins/i18n';

/* ===================
 * Main App
 * ===================
 *
 * Import the main application
 */


Vue.config.productionTip = false;

// Check support for passive events
window.passiveSupported = false;
try {
  const options = {
    get passive() {
      window.passiveSupported = true;
      return false;
    },
  };
  window.addEventListener('test', null, options);
  window.removeEventListener('test', null, options);
} catch (err) {
  window.passiveSupported = false;
}


let uuid = 1;

// TODO Use more Vuex than App component as a variables storage ; Deleting this mixin
/**
 * Mixin used for every component
 */
Vue.mixin({

  data() {
    return {
      uuid: (uuid++).toString(),
    };
  },

  computed: {
    App() {
      return this.$root && this.$root.$children && this.$root.$children[0];
    },
    /** Object: Team currently logged in */
    currentTeam() {
      return cloneDeep(this.$store.state.currentTeam);
    },
    /** Object: User currently logged in */
    currentUser() {
      return cloneDeep(this.$store.state.currentUser);
    },
    /** Boolean: Whether the current company is a free Covid-19 account */
    isCovidAccount() {
      return this.currentTeam && this.currentTeam.covidVersion;
    },
    resizeEventName() {
      return `resizeEnd.${this.uuid}`;
    },
    escKeyupEventName() {
      return `escKeyup.${this.uuid}`;
    },
    demoMode() {
      return this.App.isOnDemoMode;
    },
    appEmbedded() {
      return this.App.isEmbedded;
    },
    /**
     * Return the body element of reference for this app.
     * If the app isn't embedded, document.body. If embedded, '#app'
     * @return {HTMLElement}
     */
    documentBody() {
      if (this.appEmbedded) {
        return this.App.$el;
      }
      return document.body;
    },
    /** Boolean: Whether the action edition modal is on */
    isPbReportingDisplayed() {
      return !!this.$route.query[navUtilConsts.pbReportingQueryParam];
    },
    /** Boolean: Whether the action edition modal is on */
    isPbSheetDisplayed() {
      return !!this.$route.query[navUtilConsts.pbSheetQueryParam];
    },
    /** Boolean: Whether the action edition modal is on */
    isActionCreationDisplayed() {
      return !!this.$route.query[navUtilConsts.actionCreationQueryParam];
    },
    /** Boolean: Whether the action edition modal is on */
    isInfoCreationDisplayed() {
      return !!this.$route.query[navUtilConsts.infoCreationQueryParam];
    },
    /** Boolean: Whether the ongoing GW modal is displayed */
    isGwOngoingDisplayed() {
      return !!this.$route.query[navUtilConsts.ongoingGwQueryParam];
    },
    /** Boolean: Whether the GW creation modal is displayed */
    isGwCreationDisplayed() {
      return !!this.$route.query[navUtilConsts.gwCreationQueryParam];
    },
  },

  beforeDestroy() {
    $(window).off(this.resizeEventName);
  },

  methods: {
    /** Whether the app is gonna trigger top screen editor on EditableLabel edition */
    requiresTopScreenEditor() {
      const pc = document.getElementById('page-content');
      return isMobile && pc && pc.offsetHeight < 800;
    },
    /** Call $root.showHelp for this component */
    triggerComponentHelp() {
      this.App.showHelp(this);
    },
    /**
     * Creates a teacher button object using a translation key
     * @param  {String} trKey - key in 'sensei' translations
     * @return {Object} - 'title' and 'action' attributes
     */
    teacherBtn(trKey) {
      return {
        text: this.$t(`sensei.${trKey}_TITLE`),
        action: () => {
          this.App.iaOverlay.hide();
          IATeacher.lesson(trKey);
        },
      };
    },
    /**
     * Get the link to create/edit a problem. From any component
     * @param  {Number} pbId  Id of the problem to pass as a query param. Pass 0 to create a new problem
     * @return {String}       Link to pass to the router
     */
    getPbReportingLink(pbId) {
      return navUtils.createPbReportingLink(pbId, this.$route);
    },
    /** Get the link to edit a problem. From any component */
    getPbSheetLink(pbId) {
      return navUtils.createPbSheetLink(pbId, this.$route);
    },
    /**
     * Get the link to create/edit a action. From any component
     * @param  {Number} actionId  Id of the action to pass as a query param. Pass 0 to create a new action
     * @return {String}           Link to pass to the router
     */
    getActionCreationLink(actionId) {
      return navUtils.createActionEditionLink(actionId, this.$route);
    },
    /** Get the link to create/edit an information */
    getInfoCreationLink(infoId) {
      return navUtils.createInfoEditionLink(infoId, this.$route);
    },
    /** Get the link to start a GW */
    getGwOngoingLink(gwId) {
      return navUtils.createGwOngoingLink(gwId, this.$route);
    },
  },

});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
